module.exports = __webpack_public_path__ + "img/3.b7ce28c4.jpg";